import React from "react";

interface TermsLinkProps {
  termsText: string;
  termsUrl: string;
  className?: string;
  style?: React.CSSProperties;
  fontWeight?: string;
  underlineClass?: string;
  positionClass?: string;
}

export default function TermsLink({
  termsText,
  termsUrl,
  className = "",
  style,
  fontWeight = "font-[400]",
  underlineClass = "underline",
  positionClass = "",
}: Readonly<TermsLinkProps>) {
  return (
    <a
      href={termsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`${fontWeight} text-[14px] leading-[20px] ${underlineClass} hover:opacity-80 transition-opacity ${positionClass} ${className}`}
      style={style || { color: "#F6B052" }}
      aria-label="View terms and conditions"
    >
      {termsText}
    </a>
  );
}
